import styled from '@emotion/styled'
import { css } from '@emotion/react'

/** Right-pointing play icon (Figma ~9.59×11.49) via border triangle — same technique as step-card arrows. */
const guideTourButtonPlayIconBefore = css`
  content: '';
  display: block;
  flex-shrink: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5.75px 0 5.75px 9.59px;
  border-color: transparent transparent transparent currentColor;
`

const GUIDE_TOUR_BUTTON_BG = '#313131'
const GUIDE_TOUR_BUTTON_TEXT = '#ffffff'

export const GuideTourButtonElement = styled.button`
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;
  margin: 0;
  border: var(--border-width-small, 1px) solid transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0;
  color: color-mix(in srgb, ${GUIDE_TOUR_BUTTON_TEXT} 88%, transparent);
  background: color-mix(in srgb, ${GUIDE_TOUR_BUTTON_BG} 90%, transparent);
  padding: var(--space-1) var(--space-3);
  border-radius: 16px;
  text-decoration: none;

  &::before {
    ${guideTourButtonPlayIconBefore}
  }

  &:hover {
    background: color-mix(in srgb, ${GUIDE_TOUR_BUTTON_BG} 96%, transparent);
  }

  &:focus-visible {
    outline: 2px solid var(--foundation-border-brand, #0066cc);
    outline-offset: 2px;
  }
`
